import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import InputMask from 'react-input-mask';
import TextFieldBase from '../../Core/TextField';
import getCountryCodeAutocompleter from '../../../utils/getCountryCodeAutocompleter';
var RU_PHONE = {
  mask: '+7 fdd ddd dd dd',
  formatChars: {
    '+': '[+]',
    7: '[7]',
    f: '[0-689]',
    d: '[0-9]'
  }
};
var beforeMaskedValueChange = getCountryCodeAutocompleter(RU_PHONE, '[78]');

var PhoneField = function PhoneField(_a) {
  var value = _a.value,
      onChange = _a.onChange,
      disabled = _a.disabled,
      readOnly = _a.readOnly,
      onPaste = _a.onPaste,
      onMouseDown = _a.onMouseDown,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      props = __rest(_a, ["value", "onChange", "disabled", "readOnly", "onPaste", "onMouseDown", "onFocus", "onBlur"]);

  return _jsx(InputMask, Object.assign({
    mask: RU_PHONE.mask,
    formatChars: RU_PHONE.formatChars,
    maskChar: null,
    beforeMaskedValueChange: beforeMaskedValueChange,
    value: value,
    onChange: onChange,
    disabled: disabled,
    readOnly: readOnly,
    onPaste: onPaste,
    onMouseDown: onMouseDown,
    onFocus: onFocus,
    onBlur: onBlur
  }, {
    children: function children(inputProps) {
      return _jsx(TextFieldBase, Object.assign({}, props, inputProps, {
        disabled: disabled
      }));
    }
  }));
};

export default PhoneField;